const commonConfig = {
  serverErrorMessage:
    "Unfortunately we are unable to process this request due to connection problems. Please try again at a later time. For assistance, contact us at support@toscaltd.com.",
  anytimeCollectAuthorization:
    "Basic OTliN2E1MjUtY2Y0Ni00MzZlLWE0ZWItMzhlNjkyZWU1YTkzOmFjY291bnRzcmVjZWl2YWJsZTpFbTNyYWxkKk1AbGxhcmRIdXJyMWNhbmU1IQo=",
};

const configMap = {
  prod: {
    ...commonConfig,
    apiUrl: "https://apiprod.toscaltd.com",
    enterpriseApiKey: "d4cb370b3e744292af46dec2df206cb0",
    enterpriseApiTrace: true,
    baseApiUrl: "https://apim-toscaapi-prod.azure-api.net",
    authenticationApiUrl:
      "https://apim-toscaapi-prod.azure-api.net/authentication",
    customerProfileApiUrl:
      "https://apim-toscaapi-prod.azure-api.net/customer-profile",
    inventoryApiUrl: "https://apim-toscaapi-prod.azure-api.net/inventory",
    orderApiUrl: "https://apim-toscaapi-prod.azure-api.net/order",
    logsApiUrl: "https://apim-toscaapi-prod.azure-api.net/aggregation",
    docUrl: "https://cms.toscaltd.com",
    transportationApiUrl:
      "https://apim-toscaapi-prod.azure-api.net/transportation",
    communicationApiUrl:
      "https://apim-toscaapi-prod.azure-api.net/communication",
    environmentName: "",
    isProd: true,
    defaultSupportEmail: "support@toscaltd.com",
    promptLiveUpdate: false,
    hideCopProductDescriptions: false,
    rpcImagePath: "https://cms.toscaltd.com/hub/images/inventory/",
    hideCopCarrier: false,
    maintenanceMode: false,
    podDownloadEnable: true,
    showNewInventoryImages: false,
    clarityToken: "mfmiyaj0r2",
    showTestPushNotification: false,
    singleSign: false,
  },
  ort: {
    ...commonConfig,
    apiUrl: "https://apiprod.toscaltd.com",
    enterpriseApiKey: "d4cb370b3e744292af46dec2df206cb0",
    enterpriseApiTrace: true,
    baseApiUrl: "https://apim-toscaapi-prod.azure-api.net",
    authenticationApiUrl:
      "https://apim-toscaapi-prod.azure-api.net/authentication",
    customerProfileApiUrl:
      "https://apim-toscaapi-prod.azure-api.net/customer-profile",
    inventoryApiUrl: "https://apim-toscaapi-prod.azure-api.net/inventory",
    orderApiUrl: "https://apim-toscaapi-prod.azure-api.net/order",
    logsApiUrl: "https://apim-toscaapi-prod.azure-api.net/aggregation",
    docUrl: "https://cms.toscaltd.com",
    transportationApiUrl:
      "https://apim-toscaapi-prod.azure-api.net/transportation",
    communicationApiUrl:
      "https://apim-toscaapi-prod.azure-api.net/communication",
    environmentName: "ORT",
    isProd: false,
    defaultSupportEmail: "support@toscaltd.com",
    promptLiveUpdate: false,
    showReactQueryDevTools: false,
    hideCopCarrier: false,
    hideCopProductDescriptions: false,
    rpcImagePath: "https://cms.toscaltd.com/hub/images/inventory/",
    maintenanceMode: false,
    emailDistributionOverride: "DL_ToscaHUBTechnologyTeam@toscaltd.com",
    podDownloadEnable: true,
    showNewInventoryImages: false,
    clarityToken: "mfmiietgle",
    showTestPushNotification: false,
    singleSign: false,
  },
  uat: {
    ...commonConfig,
    apiUrl: "https://apiuat.toscaltd.com",
    enterpriseApiKey: "560d2b5f8ae24a75a9c7b2c7bfdddc03",
    enterpriseApiTrace: true,
    baseApiUrl: "https://apim-toscaapi-uat.azure-api.net",
    authenticationApiUrl:
      "https://apim-toscaapi-uat.azure-api.net/authentication",
    customerProfileApiUrl:
      "https://apim-toscaapi-uat.azure-api.net/customer-profile",
    inventoryApiUrl: "https://apim-toscaapi-uat.azure-api.net/inventory",
    orderApiUrl: "https://apim-toscaapi-uat.azure-api.net/order",
    logsApiUrl: "https://apim-toscaapi-uat.azure-api.net/aggregation",
    docUrl: "https://cmsuat.toscaltd.com",
    transportationApiUrl:
      "https://apim-toscaapi-uat.azure-api.net/transportation",
    communicationApiUrl:
      "https://apim-toscaapi-uat.azure-api.net/communication",
    environmentName: "UAT",
    isProd: false,
    defaultSupportEmail: "DL_ToscaHUBTechnologyTeam@toscaltd.com",
    promptLiveUpdate: false,
    showReactQueryDevTools: false,
    hideCopCarrier: false,
    hideCopProductDescriptions: false,
    rpcImagePath: "https://cmsuat.toscaltd.com/hub/images/inventory/",
    maintenanceMode: false,
    emailDistributionOverride: "DL_ToscaHUBTechnologyTeam@toscaltd.com",
    podDownloadEnable: true,
    showNewInventoryImages: false,
    clarityToken: "mfmi3rbf9o",
    showTestPushNotification: false,
    singleSign: false,
    salesforceUrl:
      "https://toscaltd--uat.sandbox.my.site.com/toscahub/services/auth/oauth/ToscaOIDC",
  },
  dev: {
    ...commonConfig,
    apiUrl: "https://d1rwhg2glk172w.cloudfront.net",
    enterpriseApiKey: "c34313b726f546dfa867e0ebe803c973",
    enterpriseApiTrace: true,
    baseApiUrl: "https://apim-toscaapi-dev.azure-api.net",
    authenticationApiUrl:
      "https://apim-toscaapi-dev.azure-api.net/authentication",
    customerProfileApiUrl:
      "https://apim-toscaapi-dev.azure-api.net/customer-profile",
    inventoryApiUrl: "https://apim-toscaapi-dev.azure-api.net/inventory",
    orderApiUrl: "https://apim-toscaapi-dev.azure-api.net/order",
    docUrl: "https://cmsdev.toscaltd.com",
    logsApiUrl: "https://apim-toscaapi-dev.azure-api.net/aggregation",
    transportationApiUrl:
      "https://apim-toscaapi-dev.azure-api.net/transportation",
    communicationApiUrl:
      "https://apim-toscaapi-dev.azure-api.net/communication",
    environmentName: "Dev",
    isProd: false,
    defaultSupportEmail: "DL_ToscaHUBTechnologyTeam@toscaltd.com",
    promptLiveUpdate: false,
    showReactQueryDevTools: false,
    hideCopCarrier: false,
    hideCopProductDescriptions: false,
    rpcImagePath: "https://cmsdev.toscaltd.com/hub/images/inventory/",
    maintenanceMode: false,
    emailDistributionOverride: "DL_ToscaHUBTechnologyTeam@toscaltd.com",
    podDownloadEnable: true,
    showNewInventoryImages: true,
    clarityToken: "mfmf7xhoev",
    showTestPushNotification: false,
    singleSign: true,
    salesforceUrl:
      "https://toscaltd--uat.sandbox.my.site.com/toscahub/services/auth/oauth/ToscaOIDC",
  },
  local: {
    ...commonConfig,
    apiUrl: "http://localhost:10010",
    enterpriseApiKey: "top-secret",
    enterpriseApiTrace: true,
    baseApiUrl: "http://localhost:7071",
    authenticationApiUrl: "http://localhost:7071/authentication",
    customerProfileApiUrl: "http://localhost:7072/customer-profile",
    inventoryApiUrl: "http://localhost:7073/inventory",
    orderApiUrl: "http://localhost:7074/order",
    logsApiUrl: "http://localhost:7074/aggregation",
    docUrl: "https://cmsdev.toscaltd.com",
    transportationApiUrl: "http://localhost:7074/transportation",
    communicationApiUrl: "http://localhost:7074/communication",
    environmentName: "Local",
    isProd: false,
    defaultSupportEmail: "DL_ToscaHUBTechnologyTeam@toscaltd.com",
    promptLiveUpdate: false,
    showReactQueryDevTools: false,
    hideCopCarrier: false,
    hideCopProductDescriptions: false,
    rpcImagePath: "https://cmsdev.toscaltd.com/hub/images/inventory/",
    maintenanceMode: false,
    emailDistributionOverride: "DL_ToscaHUBTechnologyTeam@toscaltd.com",
    podDownloadEnable: false,
    showNewInventoryImages: true,
    clarityToken: "mfmf7xhoev",
    showTestPushNotification: false,
    singleSign: true,
    salesforceUrl:
      "https://toscaltd--uat.sandbox.my.site.com/toscahub/services/auth/oauth/ToscaOIDC",
  },
};

const configName = process.env.REACT_APP_CONFIG_NAME
  ? process.env.REACT_APP_CONFIG_NAME
  : "dev";
const config = configMap[configName];

export { config };
